import React, { PropTypes, Component } from 'react';
import withStyles from '../../decorators/withStyles';
import styles from './GalleryPage.css';
import Gallery from '../../actions/GalleryActionCreator';
import Link from '../Link';

@withStyles(styles)
class GalleryPage extends Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    gallery: PropTypes.object
  };

  static contextTypes = {
    onSetTitle: PropTypes.func.isRequired,
    onSetMeta: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.renderUpload = this.renderUpload.bind(this);
  }

  componentDidMount() {
    var self = this;

    window.onscroll = function(ev) {
      if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight) {
        self.more();
      }
    };

    Gallery.getLast(30);
  }

  more() {
    Gallery.getMore(30);
  }

  renderConversion(item, index) {
    var downloadUrl = '/download/' + item._id;

    return (
      <a key={index} className="" href={downloadUrl} onClick={Link.handleClick}>{item.height}mm </a>
    );
  }

  renderUpload(item, index) {
    var svgUrl = '/api/preview/' + item._id;
    var convertUrl = '/convert/' + item._id;

    return (
      <div className="col-md-4 gallery-item" key={index}>
        <div className="col-md-4 no-padding">
          <img src={svgUrl} />
        </div>
        <div className="col-md-8">
          <p><strong>{item.name}</strong></p>
          {(item.conversions.length > 0) &&
            <p>
              {item.conversions.map(this.renderConversion)}
            </p>
          }
          <p>
            <a className="" href={convertUrl} onClick={Link.handleClick}>Convert to custom height</a>
          </p>
        </div>
      </div>
    );
  }

  render() {
    this.context.onSetTitle(this.props.title);
    this.context.onSetMeta('description', this.props.description);

    return (
      <div className="GalleryPage row">
        {this.props.gallery.uploads.map(this.renderUpload)}
      </div>
    );
  }

}

export default GalleryPage;



/** WEBPACK FOOTER **
 ** ./src/components/GalleryPage/GalleryPage.js
 **/